"use client";
import { jsx as e } from "react/jsx-runtime";
import { cn as p } from "@deputy-ai/common";
import { Separator as l } from "radix-ui";
function u({
  className: o,
  orientation: r = "horizontal",
  decorative: t = !0,
  ...a
}) {
  return /* @__PURE__ */ e(
    l.Root,
    {
      decorative: t,
      orientation: r,
      className: p(
        "bg-border shrink-0",
        r === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]",
        o
      ),
      ...a
    }
  );
}
export {
  u as Separator
};
